<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Revenue Share Ratio Report</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Source</u></label>
        <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source" (ngModelChange)="changeSource($event)">
          <option *ngFor="let source of sourceList" [ngValue]="source">{{source.name}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Country</u></label>
        <select [(ngModel)]="filterable.country"  class="form-control" placeholder="Country" (ngModelChange)="changeCountry($event)">
          <option *ngFor="let country of countryList | keyvalue" [ngValue]="country.value" >{{country.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Operator</u></label>
        <select [(ngModel)]="filterable.operator" class="form-control" placeholder="Operator" (ngModelChange)="changeOperator($event)">
          <option *ngFor="let op of operatorList | keyvalue" [ngValue]="op.key">{{op.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Short Code</u></label>
        <ng-select [items]="shortCodeList" placeholder="Select short code" [(ngModel)]="filterable.shortCode" class="form-control">
        </ng-select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by MT Year</u></label>
        <select [(ngModel)]="filterable.year" class="form-control" placeholder="Year">
          <option *ngFor="let year of yearList" [ngValue]="year">{{year}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by MT Month</u></label>
        <select [(ngModel)]="filterable.month" class="form-control" placeholder="Month">
          <option *ngFor="let month of monthList" [ngValue]="month.value">{{month.name}}</option>
        </select>
      </div>
      <div class="col ml-auto text-right align-self-end">
        <button class="btn btn-primary btn-sm mr-2" (click)="shareRatioExport()">分成比例</button>
        <button class="btn btn-primary btn-sm mr-2" (click)="shareRatioWithDebtExport()">分成比例&坏账</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="emptyResult">
  <div class="loader" *ngIf="loading">Loading...</div>
  <div class="alert alert-warning mt-3 w-100" *ngIf="!loading">Empty Result...</div>
</div>

<!-- <div class="table-responsive"> -->
<table id="urls" *ngIf="!emptyResult" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead>
    <tr>
      <th>NO</th>
      <th>URL</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let url of urls; index as i;">
      <td >{{i + 1}}</td>
      <td class="text-left"><a href={{url}} target="_blank">{{url}}</a> </td>
    </tr>
  </tbody>
</table>
